<template>
    <div class="document-compare-container">
        <div class="compare-pane new-version " @scroll="syncScroll">
            <div class="document-header">
                <div class="document-header-left">
                    <img class="file-icon" :src="nowVersionDetail.fileIcon" alt="" srcset="">
                    <span class="document-name one-column-ellipsis">{{ nowVersionDetail.name }}</span>
                    <div class="now-version-tips" v-if="pageType === 'lookVersion'">
                        {{ $t('versionManage.currentVersion') }}
                    </div>
                </div>
                <div class="version-num" v-if="pageType === 'lookVersion'">V{{ nowVersionDetail.version }}</div>
            </div>
            <div class="document-view" v-html="processedNewHtml"></div>
        </div>
        <div class="compare-pane old-version" @scroll="syncScroll">
            <div class="document-header">
                <div class="document-header-left">
                    <img width="16px" :src="historyVersionDetail.fileIcon" alt="" srcset="">
                    <span class="document-name one-column-ellipsis">{{ historyVersionDetail.name }}</span>
                </div>
                <div class="document-header-right">
                    <div class="version-num">V{{ historyVersionDetail.version }}</div>
                    <div class="use-history" @click="useThisVersion">{{ $t('versionManage.userVersion') }}</div>
                </div>
            </div>
            <div class="document-view" v-html="processedOldHtml"></div>
        </div>
        <div v-show="loading" class="loading-overlay">
            <div class="loader"></div>
        </div>
    </div>
</template>


<script>
// import fastDiff from 'fast-diff'

// import DiffMatchPatch from "diff-match-patch";
import {getHTMLDiff} from "./diff.js";

export default {
    name: 'DocumentCompare',
    props: {
        oldHtml: {
            type: String,
            default: ""
        },
        newHtml: {
            type: String,
            default: ""
        },
        historyVersionDetail: {
            type: Object,
            default () {
                return {}
            }
        },
        nowVersionDetail: {
            type: Object,
            default () {
                return {}
            }
        },
        pageType: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            loading: false,
            processedOldHtml: '',
            processedNewHtml: '',
            diffStats: {
                added: 0,
                removed: 0,
                modified: 0
            }
        }
    },
    mounted () {

    },
    methods: {
        //========== 主流程 ==========//
        async performDiff () {
            this.processedNewHtml = await this.parseImaUrl(this.newHtml)
            let oldHtml = getHTMLDiff(this.newHtml, this.oldHtml)
            this.processedOldHtml = await this.parseImaUrl(oldHtml)
        },
        
        syncScroll (event) {
            const containers = document.querySelectorAll('.compare-pane');
            const source = event.target;
            containers.forEach(container => {
                if (container !== source) {
                    container.scrollTop = source.scrollTop;
                    container.scrollLeft = source.scrollLeft;
                }
            });
        },
        useThisVersion () {
            this.$emit('useThisVersion')
        },
        async parseImaUrl (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            let imgList = doc.querySelectorAll('img')
            for (let index = 0; index < imgList.length; index++) {
                const img = imgList[index];
                img.getAttribute('src')
                let src = img.getAttribute('src')
                let newSrc = await this.getHtmlOssPath(src)
                img.setAttribute('src', newSrc)
            }
            return doc.documentElement.outerHTML
        },
        async getHtmlOssPath(ossPath) {
            let src = ""
            let url = '/knowledge-api/knowledge/getTemporaryCertificate?isVersionManage=1&needEncrypt=false'
            await this.$http.post(url, { fileInOssPath: ossPath }).then(async res => {
                if (res.data.code == 0) {
                    src = await res.data.data
                }
            })
            return src
        }
    },
    watch: {
        oldHtml: {
            handler (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.performDiff();
                    })
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped lang="less">
.document-compare-container {
    display: flex;
    height: 100%;
    background: #f8f9fa;
    overflow: hidden;
    flex: 1;

    .old-version {
        flex: 0.5;
        padding: 20px;
    }

    .new-version {
        flex: 0.5;
        padding: 20px;
    }

    .document-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        font-size: 16px;

        .file-icon {
            width: 16px;
            vertical-align: middle;
        }

        .document-header-left, .document-header-right {
            display: flex;
            align-items: center;
        }

        .document-name {
            color: #000;
            margin-left: 4px;
        }

        .now-version-tips {
            width: 64px;
            height: 19px;
            background: #E6ECFF;
            border: 1px solid #CDDAFF;
            border-radius: 9px;
            color: #366AFF;
            font-size: 12px;
            text-align: center;
            line-height: 19px;
            margin-left: 10px;
            flex-shrink: 0;
        }

        .version-num {
            margin-left: 10px;
            padding: 0 5px;
            height: 19px;
            background: #E7EAF1;
            border-radius: 2px;
            color: #000000;
            font-size: 12px;
        }

        .use-history {
            width: 80px;
            height: 24px;
            background: #366AFF;
            border-radius: 15px;
            font-size: 12px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            //line-height: 31px;
            margin-left: 10px;
        }
    }

    /deep/ img {
        max-width: 100%;
    }
}

.compare-pane {
    flex: 1;
    overflow-y: auto;
    background: white;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    position: relative;
}

.document-view {
    max-width: 800px;
    margin: 0 auto;
    padding: 40px;
    font-family: 'SimSun', serif;
    line-height: 1.8;
}

.version-label {
    position: fixed;
    top: 20px;
    right: 20px;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    z-index: 10;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}

.loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>

<!-- 全局样式 -->
<style lang="less" scoped>
/deep/ .diffdel, /deep/ del {
    background: #ffebee !important;
    color: #c62828 !important;
    padding: 0 2px !important;
    font-weight: bold !important;
    margin: 0 2px !important;
    position: relative!important;
}

/deep/ .diffins, /deep/ ins {
    background: #e8f5e9 !important;
    color: #2e7d32 !important;
    padding: 0 2px !important;
    margin: 0 2px !important;
    font-weight: bold !important;
    position: relative!important;

}

/deep/ .diffmod {
    // background: #fff3e0!important;
    // color: #e65100!important;
    // padding: 0 2px!important;
    // margin: 0 2px!important;
    // font-weight: bold !important;
}
/deep/.ins_tip:before  {
    content: "新增";
    // position: absolute;
    width: auto;
    height: 50px;
    top: -20px;
    left: 0;
    font-size: 12px;
    border-left: 2px solid #2e7d32;
    margin-right: 2px;
    background: #2e7d32!important;
    padding: 0 2px!important;
    border-radius: 2px;
    color: #e8f5e9!important;
    // background: #2e7d32 !important;
    // color: #2e7d32 !important;
}
/deep/.del_tip:before  {
    content: "删除";
    // position: absolute;
    width: auto;
    height: 50px;
    top: -20px;
    left: 0;
    font-size: 12px;
    // border-left: 2px solid #c62828;
    margin-right: 2px;
    background: #c62828!important;
    padding: 0 2px!important;
    border-radius: 2px;
    color: #ffebee!important;
    text-decoration: none !important;
    // background: #2e7d32 !important;
    // color: #2e7d32 !important;
}

// /deep/del {
//     background: #ffebee !important;
//     color: #c62828 !important;
//     padding: 0 2px !important;
//     font-weight: bold !important;
//     margin: 0 2px!important;
// }
// /deep/ ins {
//     background: #e8f5e9!important;
//     color: #2e7d32!important;
//     padding: 0 2px!important;
//     margin: 0 2px!important;
//     font-weight: bold !important;
// }
</style>

